export default "__VITE_ASSET__1faafd21__"